export default "__VITE_ASSET__B65m56em__"